<div class="modal-header" id="about-modal-header">
  <h1 class="logo float-left">
      North Carolina Judicial Branch
  </h1>
  <button class="btn btn-primary btn-ciprs pull-right" (click)="hideModal()" id="about-top-close-btn">Close</button>
</div>
<div class="modal-body container-fluid">

  <div class="well well-sm about-user-notice-border" *ngIf="isICMSReleased()">
      <h4 class="about-notice-area">
          <b>Please note that…</b>
      </h4>
      <p class="about-notice-area">
          This program no longer shows case information for all counties in North Carolina.
      </p>
      <p class="about-notice-area" >
          The North Carolina Courts are implementing new court technology to improve access to justice for all North Carolinians. To search for or view public court case information for counties which already have the new technology, please visit <b>https://www.nccourts.gov/ecourts#portal-10445</b> on any device with internet access.
      </p>
  </div>

  <div id="about-release-notes-outer-div" class="well well-lg">
      <p id="about-release-notes-loading-message">
        <b>The release notes may take a few seconds to load...</b> <i class="fa fa-spinner fa-pulse fa-2x text-center"></i>
      </p>
      <div id="about-release-notes-div">  
        <object id="about-release-notes" data="./assets/pdf/CIPRS Release Notes.pdf#toolbar=0&navpanes=0" type="application/pdf"></object>
      </div>  
  </div>
</div>
<div class="modal-footer">
  <div class="row">
    <div class="col-md-12 pull-left text-left" id="about-build-info">
      <p>Version {{ appVersion }}</p>
      <p>Build# {{ buildDate }}</p>
      <button class="btn btn-primary btn-ciprs pull-right" (click)="hideModal()" id="about-close-bottom-btn">Close</button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/about/about.component.html